import $ from 'jquery';

import Section from '../Section';

export default class Password extends Section {
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.load();
  }

  load = () => {
    document.getElementById('password').focus();
    $("#password-show").click(function() {
      $("#site-header").slideToggle( "slow");
    });
    $(".password--close a").click(function() {
      $("#site-header").slideToggle( "slow");
    });
    $(function() {
      if ($('.storefront-password-form .errors').length) {
        $("#site-header").slideToggle("slow");
      }
    });
  }
}
